/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConfirmQuarantinedResponseParser = 
/* #__PURE__ */ parsers.object([
    ['status', /* #__PURE__ */ parsers.exactly('quarantined')],
]);
export class ConfirmQuarantinedResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConfirmQuarantinedResponseParser.decode(input).map(res => new ConfirmQuarantinedResponse(res));
    }
    static unsafeDecode(input) {
        return ConfirmQuarantinedResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmQuarantinedResponseParser.encode(data);
    }
    static schema() {
        return ConfirmQuarantinedResponseParser.schema();
    }
}
